import { createSlice } from '@reduxjs/toolkit';
import { useSelector, useDispatch } from 'react-redux';
import {
  CashTenureMigrationApi,
  CashTenureMigrationApi_extrareducer,
} from './cash-tenure-migration/index';

const initialState = {
  cashTenureMigrationApiState: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
};

export const CashTenureMigrationSlice = createSlice({
  name: 'cashTenureMigration',
  initialState,
  extraReducers: {
    ...CashTenureMigrationApi_extrareducer,
  },
});

export function useCashTenureMigrationStore() {
  const cashTenureMigrationApiState = useSelector(
    (state) => state.cashTenureMigration.cashTenureMigrationApiState
  );

  const dispatch = useDispatch();

  return {
    cashTenureMigrationApiState,
    CashTenureMigrationApi: (payload) => {
      return dispatch(CashTenureMigrationApi(payload));
    },
  };
}

export default CashTenureMigrationSlice.reducer;
